import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import AddLocationButton from "./AddLocationButton";
import { useNitroStore } from "../../store/Store";
import { useIsMobile } from "../../hooks/useIsMobile";
import "./index.css";

const NitroMapButtons = () => {
  const isMobile = useIsMobile(768);
  const [mapType, setMapType, selectingPinLocation] = useNitroStore((state) => [
    state.mapType,
    state.setMapType,
    state.selectingPinLocation,
  ]);

  if (selectingPinLocation) return null;

  if (isMobile) return null;

  return (
    <div id="MapButtons" className="map-buttons">
      <div className="buttonPanel">
        <div className="buttonPanelToggle">
          <ToggleButtonGroup
            className="mapTypeToggleGroup"
            size="medium"
            orientation="vertical"
            value={mapType}
            exclusive
            sx={{
              paddingRight: "21px",
              border: "none",
              background: "transparent",
              "& .MuiButtonBase-root.MuiToggleButton-root": {
                boxShadow: "none !important",
                color: "#4b4b4b !important",
                background: "#ffffff !important",
              },
              "& .MuiButtonBase-root.MuiToggleButton-root:hover": {
                boxShadow: "none !important",
                color: "#4b4b4b !important",
                background: "#ffffff !important",
              },
              "& .MuiButtonBase-root.MuiToggleButton-root.Mui-selected": {
                boxShadow: "none !important",
                color: "#ffffff !important",
                background: "#60a5fa !important",
              },
              "& .MuiButtonBase-root.MuiToggleButton-root.Mui-selected:hover": {
                boxShadow: "none !important",
                color: "#ffffff !important",
                background: "#60a5fa !important",
              },
              "& .MuiToggleButtonGroup-grouped": {
                borderLeft: "1.16px solid #60a5fa !important",
                borderRight: "1.16px solid #60a5fa !important",
                margin: 0,
              },
              "& .MuiToggleButtonGroup-grouped:first-of-type": {
                borderTop: "1.16px solid #60a5fa !important",
                borderRadius: "12px 12px 0 0 !important",
              },
              "& .MuiToggleButtonGroup-grouped:not(:first-of-type)": {
                borderTop: "0 !important",
              },
              "& .MuiToggleButtonGroup-grouped:last-of-type": {
                borderBottom: "1.16px solid #60a5fa !important",
                borderRadius: "0 0 12px 12px !important",
              },
            }}
            onChange={(e, value) => {
              if (!value) return;

              setMapType(value);
            }}
          >
            <ToggleButton
              className="mapTypeToggleButton"
              sx={{ fontSize: "inherit" }}
              value="roadmap"
            >
              Map
            </ToggleButton>
            <ToggleButton
              className="mapTypeToggleButton"
              sx={{ fontSize: "inherit" }}
              value="hybrid"
            >
              Satellite
            </ToggleButton>
          </ToggleButtonGroup>
        </div>
        <AddLocationButton />
      </div>
    </div>
  );
};
export default NitroMapButtons;
